import { useState, useCallback } from 'react';
import { useRoomContext } from '@livekit/components-react';
import { useDispatch } from 'react-redux';
import { SEND_TARGETED_REACTION } from '../../../constants/meeting';
import useReactions from './useReactions';

export const useTargetedReactions = () => {
  const room = useRoomContext();
  const dispatch = useDispatch();
  const { addTargetedReaction } = useReactions();
  const [selectedParticipant, setSelectedParticipant] = useState(null);

  const getAllParticipants = () => {
    if (!room) return [];

    const participants = [];

    if (room.localParticipant) {
      participants.push({
        identity: room.localParticipant.identity,
        name: room.localParticipant.name || room.localParticipant.identity,
        isLocal: true,
      });
    }

    room.remoteParticipants?.forEach((participant) => {
      participants.push({
        identity: participant.identity,
        name: participant.name || participant.identity,
        isLocal: false,
      });
    });

    return participants;
  };

  const sendTargetedReaction = useCallback(
    (reaction, userIdentity) => {
      if (!userIdentity) return;

      dispatch({
        type: SEND_TARGETED_REACTION.REQUEST,
        payload: { reaction, userId: Number(userIdentity) },
        callback: ({ reactionEmoji: emoji }) => {
          addTargetedReaction(userIdentity, emoji);
          setSelectedParticipant(null);
        },
      });
    },
    [dispatch, addTargetedReaction, setSelectedParticipant]
  );

  return {
    getAllParticipants,
    selectedParticipant,
    setSelectedParticipant,
    sendTargetedReaction,
  };
};

export default useTargetedReactions;
